import communityWalkthrough from '../../modules/community/walkthrough/ve.json';

export const VE = {
  translation: {
    ...communityWalkthrough,
  },
};
